<template>
  <div style="overflow: hidden;" id="app">
    <div style="display: flex; flex-direction: row; height: 100%; ">
      <div v-if="device === 'mobile' && !isCollapse" style="position: relative; min-width: 240px;" class="sidebar-container mobile">
        <el-row class="rowTop">
          <span style="width: 100%; text-align: left; color: #000; font-size: 16px; font-weight: bold;">{{ appname ? appname : '' }}</span>
        </el-row>
        <el-row v-if="username" class="rowTop">
          <span style="width: 100%; text-align: left; color: #000; font-size: 16px; font-weight: normal;">{{ username }}</span>
        </el-row>
        <el-scrollbar wrapClass="scrollbar-wrapper">
          <el-menu
            mode="vertical"
            :show-timeout="200"
            :default-active="$route.path"
            :collapse="isCollapse"
            style="height: auto;"
          >
            <sidebar-item :routes="permission_routers"></sidebar-item>
          </el-menu>
          <el-menu
            mode="vertical"
            :show-timeout="200"
            :default-active="$route.path"
            :collapse="isCollapse"
            style="height: auto;"
          >
            <div class="menu-wrapper">
              <template v-if="awakRole === 'none'">
                <!-- <div @click="kick('/pilih')">
                  <el-menu-item index="/pilih" class="submenu-title-noDropdown">
                    <i class="el-icon-s-home"></i>
                    <span slot="title">Home</span>
                  </el-menu-item>
                </div> -->
                <el-menu-item index="/logout" @click="logout" class="submenu-title-noDropdown">
                  <i style="color: #000;" class="el-icon-switch-button"></i>
                  <span slot="title">Log Out</span>
                </el-menu-item>
              </template>
              <template v-else-if="awakRole === 'basic'">
                <!-- <div @click="kick('/pilih')">
                  <el-menu-item index="/pilih" class="submenu-title-noDropdown">
                    <i class="el-icon-s-home"></i>
                    <span slot="title">Home</span>
                  </el-menu-item>
                </div> -->
                <div @click="kick('/')">
                  <el-menu-item index="/" class="submenu-title-noDropdown">
                    <i class="el-icon-date"></i>
                    <span slot="title">Order</span>
                  </el-menu-item>
                </div>
                <div @click="kick('/billing')">
                  <el-menu-item index="/billing" class="submenu-title-noDropdown">
                    <i class="el-icon-money"></i>
                    <span slot="title">Billing</span>
                  </el-menu-item>
                </div>
                <el-menu-item index="/logout" @click="logout" class="submenu-title-noDropdown">
                  <i style="color: #000;" class="el-icon-switch-button"></i>
                  <span slot="title">Log Out</span>
                </el-menu-item>
              </template>
              <template v-else>
                <div @click="kick('/dashboard')">
                  <el-menu-item index="/dashboard" class="submenu-title-noDropdown">
                    <i class="el-icon-s-home"></i>
                    <span slot="title">Home</span>
                  </el-menu-item>
                </div>
                 <el-submenu>
                  <template class="submenu-title-noDropdown" slot="title">
                    <i class="el-icon-s-order"></i>
                    <span>Products</span>
                  </template>
                  <a href="https://outwork.work" target="_blank" rel="noopener noreferrer">
                    <el-menu-item class="submenu-title-noDropdown">
                      <i class="el-icon-s-cooperation"></i>
                      <span slot="title">OutWork</span>
                    </el-menu-item>
                  </a>
                  <!-- <a href="https://pay.xfero.io" target="_blank" rel="noopener noreferrer">
                    <el-menu-item class="submenu-title-noDropdown">
                      <i class="el-icon-s-cooperation"></i>
                      <span slot="title">XFERO Payment</span>
                    </el-menu-item>
                  </a>
                  <a href="https://park.xfero.xyz" target="_blank" rel="noopener noreferrer">
                    <el-menu-item class="submenu-title-noDropdown">
                      <i class="el-icon-s-cooperation"></i>
                      <span slot="title">XFERO Parking</span>
                    </el-menu-item>
                  </a>
                  <a href="https://analytics.xfero.io" target="_blank" rel="noopener noreferrer">
                    <el-menu-item class="submenu-title-noDropdown">
                      <i class="el-icon-s-cooperation"></i>
                      <span slot="title">XFERO Analytics</span>
                    </el-menu-item>
                  </a> -->
                </el-submenu>
              </template>
            </div>
          </el-menu>
        </el-scrollbar>
      </div>
      <div :style="device === 'mobile' && globalSidebar === true ? 'left: 180px; position: absolute;' : ''" style="display: flex; flex-direction: column; height: 100%; width: 100%;">
        <header v-if="burgerAllowed" style="height: 65px;">
          <div class="headerClass">
            <div v-if="isCollapse" style="display: flex; flex: 1; align-items: center; justify-content: flex-start; flex-direction: row;">
              <!-- <a href="/" style="color: #000; font-size: 24px; font-family: CaviarDreams; font-weight: bold;">{{title}}</a> -->
              <a href="/">
                <img class="appLogo2" :src="xfero"/>
              </a>
            </div>
            <nav v-if="device !== 'mobile'" style="flex: 2; display: flex; justify-content: flex-start; align-items: center;">
              <div style="width: 100%;">
                <ul v-if="awakRole === 'basic'" style="display: flex; list-style: none; margin: 0; padding: 0; flex-direction: row; flex-wrap: wrap; wdith: 100%;">
                  <!-- <li style="padding: 0; flex: 1;">
                    <a href="/pilih" class="headerLink">HOME</a>
                  </li> -->
                  <!-- <li style="padding: 0; flex: 1;">
                    <a href="/" class="headerLink">ORDER</a>
                  </li>
                  <li style="padding: 0; flex: 1;">
                    <a href="/billing" class="headerLink">BILLING</a>
                  </li> -->
                </ul>
                <ul v-else style="display: flex; list-style: none; margin: 0; padding: 0; flex-direction: row; flex-wrap: wrap; wdith: 100%;">
                  <!-- <li style="padding: 0; flex: 1;">
                    <a href="/dashboard" class="headerLink">HOME</a>
                  </li> -->
                </ul>
              </div>
            </nav>
            <div v-if="token === '' && device !== 'mobile'" style="flex: 1; display: flex; flex-direction: row; align-items: center; justify-content: flex-end;">
              <el-dropdown style="margin-right: 40px;" trigger="click">
                <span style="cursor: pointer; color: #000;">
                  PRODUCTS
                  <i class="el-icon-caret-bottom"></i>
                </span>
                <el-dropdown-menu class="user-dropdown" slot="dropdown">
                  <a href="https://outwork.work" target="_blank" rel="noopener noreferrer">
                    <el-dropdown-item>
                      <span style="display:block;">OutWork</span>
                    </el-dropdown-item>
                  </a>
                  <!-- <a href="https://pay.xfero.io" target="_blank" rel="noopener noreferrer">
                    <el-dropdown-item>
                      <span style="display:block;">XFERO Payment</span>
                    </el-dropdown-item>
                  </a>
                  <a href="https://park.xfero.xyz" target="_blank" rel="noopener noreferrer">
                    <el-dropdown-item>
                      <span style="display:block;">XFERO Parking</span>
                    </el-dropdown-item>
                  </a>
                  <a href="https://analytics.xfero.io" target="_blank" rel="noopener noreferrer">
                    <el-dropdown-item>
                      <span style="display:block;">XFERO Analytics</span>
                    </el-dropdown-item>
                  </a> -->
                </el-dropdown-menu>
              </el-dropdown>
              <span @click="google" style="display: inline-block; cursor: pointer; position: relative; font-size: 14px;">SIGN IN</span>
            </div>
            <div v-else-if="device !== 'mobile'" style="flex: 1; display: flex; flex-direction: row; align-items: center; justify-content: center;">
              <!-- <span v-if="awakRole === 'basic'" style="font-size: 1em; color: #666;">{{ balance }} Tokens</span> -->
              <el-dropdown style="margin-left: 10px;" trigger="click">
                <span style="cursor: pointer; color: #000;">
                  <i class="el-icon-user-solid"></i>
                  {{username}}
                  <i class="el-icon-caret-bottom"></i>
                </span>
                <el-dropdown-menu class="user-dropdown" slot="dropdown">
                  <el-dropdown-item>
                    <span @click="logout" style="display:block;">Log Out</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <!-- <span v-if="awakRole === 'basic' && device === 'mobile'" style="font-size: 0.8em; color: #666; margin-right: 20px;">{{ balance }} Tokens</span> -->
            <hamburger v-if="device === 'mobile'" style="position: relative; display: flex; flex-direction: row;" class="hamburger-container" :toggleClick="toggleGlobalSideBar" :isActive="globalSidebar.opened" :color="1"></hamburger>
          </div>
        </header>
        <div @click="handleClickOutside()" style="flex: 1; overflow: scroll;" ref="appbody">
          <router-view></router-view>
          <a href="https://api.whatsapp.com/send?phone=60163768137&text=Hi%20xfero.io,%20" class="float" target="_blank">
            <i class="fab fa-whatsapp my-float"></i>
          </a>
          <div v-if="device !== 'mobile'" class="footerClass">
            <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
              <p style="width: 400px; text-align: center; font-size: 12px;">Copyright © 2015-2022 <a href="https://www.xfero.io" target="_blank" rel="noopener noreferrer" style="text-decoration: underline;">{{appname}}</a> Sdn Bhd <span>(11</span><span style="margin-left: 4px;">68</span><span style="margin-left: 4px;">264</span style="margin-left: 4px;"><span style="margin-left: 4px;">-</span><span style="margin-left: 4px;">H)</span>. <br> All rights reserved.</p>
            </div>
            <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
              <p style="width: 400px; text-align: center; font-size: 12px;"><span style="cursor: pointer;" @click="legal">Legal Terms</span> | <span style="cursor: pointer;" @click="privacy">Privacy Policy</span> | <span style="cursor: pointer;" @click="cookie">Cookie Policy</span></p>
            </div>
          </div>
          <div v-else class="footer2Class">
            <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
              <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                <p style="width: 100%; text-align: center; font-size: 12px; margin: 0; border: 0; padding: 0; box-sizing: border-box;">Copyright © 2015-2022 <a href="https://www.xfero.io" target="_blank" rel="noopener noreferrer" style="text-decoration: underline;">{{appname}}</a> Sdn Bhd <span>(11</span><span style="margin-left: 4px;">68</span><span style="margin-left: 4px;">264</span style="margin-left: 4px;"><span style="margin-left: 4px;">-</span><span style="margin-left: 4px;">H)</span>. <br> All rights reserved.</p>
              </div>
              <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; margin-top: 10px;">
                <p style="width: 100%; text-align: center; font-size: 12px; margin: 0; border: 0; padding: 0; box-sizing: border-box;"><span style="cursor: pointer;" @click="legal">Legal Terms</span> | <span style="cursor: pointer;" @click="privacy">Privacy Policy</span> | <span style="cursor: pointer;" @click="cookie">Cookie Policy</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <cookie-law theme="xfero"></cookie-law>
    </footer>
  </div>
</template>

<script>
import xfero from '@/assets/xfero_logo-og.png'
import axios from 'axios'
import CookieLaw from 'vue-cookie-law'
import Hamburger from '@/components/Hamburger'
import { mapGetters } from 'vuex'
import SidebarItem from './views/admin/layout/components/Sidebar/SidebarItem'
import '@/permission'
import ResizeMixin from '@/mixin/ResizeHandler'

export default {
  name: 'App', components: { CookieLaw, Hamburger, SidebarItem },
  mixins: [ResizeMixin],
  data() {
    return {
      title: process.env.APP_NAME.toUpperCase(),
      appname: process.env.APP_NAME,
      xfero
    }
  },
  methods: {
    toggleGlobalSideBar() {
      this.$store.dispatch('ToggleGlobalSideBar')
    },
    signIn() {
      this.$store.dispatch('OpenSignInPopup', { subscribe: false })
    },
    signInClose() {
      this.$store.dispatch('CloseSignInPopup')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        this.$store.dispatch('ResetRoutes').then(() => {
          // console.log(this.$store.getters.permission_routers)
          this.$router.push('/?logout=true')
        })
      })
    },
    handleClickOutside() {
      this.$store.dispatch('CloseGlobalSideBar', { withoutAnimation: false })
    },
    kick(route) {
      this.$router.push(route)
    },
    async google() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        const googleUser = await this.$gAuth.signIn()
        const resp = await axios.get('https://api-master.xfero.io/auth/google/callback', {
          params: {
            access_token: googleUser.getAuthResponse().access_token
          }
        })
        resp.data.profile = googleUser.getBasicProfile()
        this.$store.dispatch('SignInPlatform', resp.data).then((data) => {
          // this.$store.dispatch('GetBalance')
          loading.close()
          location.reload()
        })
      } catch (err) {
        // console.log('err: ', err)
        loading.close()
      }
    },
    legal() {
      window.open('/legal')
    },
    privacy() {
      window.open('/privacy')
    },
    cookie() {
      window.open('/cookie')
    },
    payment() {
      window.open('https://pay.xfero.io')
    },
    parking() {
      window.open('https://park.xfero.xyz')
    }
  },
  computed: {
    username() {
      return this.$store.state.user.username
    },
    awakRole() {
      return this.$store.state.user.awakRole
    },
    token() {
      return this.$store.state.user.token
    },
    // balance() {
    //   return this.$store.state.user.balance
    // },
    globalSidebar() {
      return this.$store.state.app.globalSidebar
    },
    signInPopup() {
      return this.$store.state.app.signInPopup
    },
    device() {
      return this.$store.state.app.device
    },
    isCollapse() {
      return !this.$store.state.app.globalSidebar.opened
    },
    burgerAllowed() {
      return this.$store.state.app.burgerAllowed
    },
    ...mapGetters([
      'permission_routers'
    ])
  },
  mounted() {
  },
  beforeRouteLeave(to, from, next) {
    this.$Tawk.$endChat()
  }
}
</script>

<style lang='scss'>
@import './styles/variables.scss';
@font-face { font-family: College; src: url('./fonts/college/college.ttf'); } 
@font-face { font-family: College; font-weight: bold; src: url('./fonts/college/collegeb.ttf'); } 
@font-face { font-family: CaviarDreams; src: url('./fonts/caviar_dreams/CaviarDreams.ttf'); } 
@font-face { font-family: CaviarDreams; font-weight: bold; src: url('./fonts/caviar_dreams/CaviarDreams_Bold.ttf'); } 

.Cookie--xfero {
  background-color: #fff;
  color: #000;
  padding: 1.250em;
}

.Cookie--xfero .Cookie__button {
  border-radius: 4px;
  background: #4285f4;
  padding: 0.625em 3.125em;
  color: #fff;
  border: 0;
  font-size: 1em;
}

.Cookie--xfero .Cookie__button:hover {
  background: #4285f4;
}
.Cookie--xfero .Cookie__button:focus {
  background: #4285f4;
}

.appLogo2 {
  height: 35px;
}

h1 {
  color: $color1;
}

.normal-text{
  color: #fff;
  padding: 20px 2%;
}

.hyperlink{
  color: cyan;
}

.headerClass {
  border-bottom-width: 1px;
  border-bottom-color: rgba(0,0,0,0.2);
  border-bottom-style: solid;
  height: 65px;
  padding: 0px 5%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: $color5;
  .headerLink {
    display: block;
    font-size: 18px;
    color: $color1;
    padding-top: 15px;
    padding-right: 0px;
    padding-bottom: 16px;
    padding-left: 0px;
    text-align: center;
  }
}

.footerClass {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: $color1;
  background-color: #fff;
  border-top: 1px solid #aaa;
  padding: 10px 0px;
  height: 100px;
}

.footer2Class {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: $color1;
  background-color: #fff;
  border-top: 1px solid #aaa;
  padding: 10px 10px;
  height: 100px;
}

.titleColor {
  color: $color1;
}

.titleColor:focus {
  color: $color1;
}
.titleColor:hover {
  color: $color1;
}
.rowTop {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 20px;
  height: 56px;
  background-color: #fff;
}
.float{
	position:fixed;
	width:60px;
	height:60px;
	bottom:40px;
	right:40px;
	background-color:#25d366;
	color:#FFF;
	border-radius:50px;
	text-align:center;
  font-size:30px;
	box-shadow: 2px 2px 3px #999;
  z-index:1000;
}
.float2{
	position:fixed;
	width:60px;
	height:60px;
	bottom:80px;
	right:10px;
	background-color:#25d366;
	color:#FFF;
	border-radius:50px;
	text-align:center;
  font-size:30px;
	box-shadow: 2px 2px 3px #999;
  z-index:100;
}

.my-float{
	margin-top:16px;
}

@media (max-width: 520px) {
  .float {
    right: 20px;
  }
}

/*Fixes double tap on iOS*/
.el-scrollbar__bar {
  opacity: 1!important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue